// extracted by mini-css-extract-plugin
module.exports =  {"badge":"FkHiXlu","all-caps":"Km1wC4c","allCaps":"Km1wC4c"};